export const RADIO_GROUP_SX = {
  '.chakra-radio__control': {
    w: '16px !important',
    h: '16px !important',
    minW: '16px',
    minH: '16px',
  },
  '.chakra-radio__control[data-checked]': {
    bg: '#F0F0F0',
    borderColor: '#243744',
    color: '#243744',
    _hover: { bg: '#F0F0F0', borderColor: '#243744' },
    _before: { bg: '#243744' },
  },
  '.chakra-radio__control:hover': {
    borderColor: '#243744',
  },
  '.chakra-radio__label': {
    color: 'black',
    opacity: 1,
  },
};
